export const DEBUG_SEARCH_QUERY = '~/debug:true'

export const DEBUG_FUND = {
  isDebugFund: true,
  schemeCode: 'DEBUG_FUND',
  amcCode: 'DEBUG',
  legalName: 'Debug Fund',
  sName: 'Debug Fund',
  schemeName: 'Debug Fund',
  threeYrRet: 0,
  minInvt: 0,
}

export const isDebugSearchQuery = (query) => query?.trim() === DEBUG_SEARCH_QUERY
